import { HelpCircle } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface SliderHelpTooltipProps {
  title: string;
  description: string;
  subcategories?: string[];
  example?: string;
}

export function SliderHelpTooltip({ 
  title, 
  description, 
  subcategories, 
  example 
}: SliderHelpTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={300}>
        <TooltipTrigger asChild>
          <button
            type="button"
            className="inline-flex items-center justify-center text-muted-foreground hover:text-foreground transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-full"
            aria-label={`Help for ${title}`}
          >
            <HelpCircle className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent 
          side="top" 
          align="start"
          className="max-w-[320px] p-3 space-y-2"
        >
          <p className="font-medium text-sm">{title}</p>
          <p className="text-sm text-muted-foreground">{description}</p>
          
          {subcategories && subcategories.length > 0 && (
            <div className="space-y-1">
              <p className="text-xs font-medium text-muted-foreground">Includes jobs like:</p>
              <ul className="text-xs text-muted-foreground space-y-0.5 max-h-[120px] overflow-y-auto">
                {subcategories.map((sub) => (
                  <li key={sub} className="flex items-start gap-1">
                    <span className="text-muted-foreground/60">•</span>
                    <span>{sub}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          {example && (
            <div className="pt-1 border-t border-border">
              <p className="text-xs">
                <span className="font-medium">Example: </span>
                <span className="text-muted-foreground">{example}</span>
              </p>
            </div>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
